import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

const ChallengeSection = ({
  description,
}) => {
  return (
    <Paper
      className="drawn"
      sx={{
        display: 'grid',
        p: 3,
      }}
    >
      <Stack
        display="grid"
        gap={2}
        justifyContent="center"
        justifySelf="center"
        textAlign="center"
        maxWidth="650px"
        width="100%"
        sx={theme => ({
          'h2': {
            ...theme.typography.sectionLabel,
          },
          'p': {
            ...theme.typography.body1,
            color: theme.palette.text.neutralDark,
          },
        })}
      >
        {description}
      </Stack>
    </Paper>
  )
}

export default ChallengeSection